import * as React from 'react';
import * as styles from './mvk.css';
import { useFloorPlan } from '../../hooks/useFloorPlanFetcher';
import { FloorPlan } from './parts/FloorPlan';
import { tracking as configTracking } from '../../tracking/tracking';
import { TrackingContext } from '../../tracking/TrackingContext';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Мастер выбора квартир
 */
export var MVK = function MVK(_ref) {
  var newbuildingId = _ref.newbuildingId,
    houseId = _ref.houseId,
    sectionId = _ref.sectionId,
    pageTypeJK = _ref.pageTypeJK;
  var _useFloorPlan = useFloorPlan({
      newbuildingId: newbuildingId,
      houseId: houseId,
      sectionId: sectionId
    }),
    isError = _useFloorPlan.isError,
    isLoading = _useFloorPlan.isLoading,
    floorPlan = _useFloorPlan.floorPlan,
    loadPlan = _useFloorPlan.loadPlan;
  var tracking = configTracking(newbuildingId, pageTypeJK);
  return /*#__PURE__*/_jsx("div", {
    className: styles['mvk'],
    "data-testid": "MVK",
    children: /*#__PURE__*/_jsx(TrackingContext.Provider, {
      value: tracking,
      children: /*#__PURE__*/_jsx(FloorPlan, {
        floorPlan: floorPlan,
        isError: isError,
        isLoading: isLoading,
        loadPlan: loadPlan
      })
    })
  });
};